<template>
  <span :class="ns.e('item')">
    <span ref="link" :class="[ns.e('inner'), ns.is('link', !!to)]" role="link">
      <slot></slot>
    </span>
    <span :class="ns.e('separator')" role="presentation">
      <slot name="separator">
        {{ separator }}
      </slot>
    </span>
  </span>
</template>

<script lang="ts">
import {
  defineComponent,
  inject,
  ref,
  onMounted,
  getCurrentInstance,
} from 'vue'
import SgIcon from '@sgui-plus/components/icon'
import { BreadcrumbContextKey } from './constants'
import { useNamespace } from '@sgui-plus/hooks'
import { breadcrumbItemProps } from './breadcrumb-item'

import type { Router } from 'vue-router'

const COMPONENT_NAME = 'SgBreadcrumbItem'

export default defineComponent({
  name: COMPONENT_NAME,

  components: {
    SgIcon,
  },

  props: breadcrumbItemProps,

  setup(props) {
    const instance = getCurrentInstance()!
    const router = instance.appContext.config.globalProperties.$router as Router
    const parent = inject(BreadcrumbContextKey, undefined)
    const ns = useNamespace('breadcrumb')

    const link = ref<HTMLSpanElement>()

    onMounted(() => {
      link.value!.setAttribute('role', 'link')
      link.value!.addEventListener('click', () => {
        if (!props.to || !router) return
        props.replace ? router.replace(props.to) : router.push(props.to)
      })
    })

    return {
      ns,
      link,
      separator: parent?.separator
    }
  },
})
</script>
